import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import { Button } from '../components/MUI/button/Button';
import { useAppThemeContext } from '../contexts';

type Props = {
  children?: React.ReactNode;
  heightDefault?: number;
  header?: string | React.ReactNode;
  hideSaveButton?: boolean;
  saveButtonLabel?: string;
  saveButtonDataTestId?: string;
  isLoading?: boolean;
  disabled?: boolean;
  isSubmit?: boolean;
  onClickSave?: () => void;
};

export const LayoutRegister: React.FC<Props> = ({ children, header, hideSaveButton, saveButtonLabel, saveButtonDataTestId, isLoading, disabled, isSubmit, onClickSave }) => {
  const { isTablet: mdDown } = useAppThemeContext();

  return (
    <Grid container component={Paper} variant='outlined' sx={{ width: '100%', borderRadius: 4 }}>
      {header &&
        <>
          <Grid item xs={12}>
            {typeof (header) === 'string' &&
              <Box display='flex' flex={1} justifyContent='center' padding={3}>
                <Typography variant={mdDown ? 'h6' : 'h5'}>{header}</Typography>
              </Box>
            }

            {typeof (header) === 'object' &&
              <>
                {header}
              </>
            }
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
        </>
      }

      <Grid item xs={12} >
        <Box padding={3}>
          {children}
        </Box>
      </Grid>

      {!hideSaveButton &&
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} display='flex' justifyContent='end' height={68.5} padding={2}>
            <Button
              variant='contained'
              label={saveButtonLabel ?? 'Salvar'}
              minWidth={200}
              onClick={onClickSave}
              isLoading={isLoading}
              disabled={isLoading || disabled}
              type={isSubmit ? 'submit' : 'button'}
              data-testid={saveButtonDataTestId ?? 'btn-save'}
            />
          </Grid>
        </Grid>
      }
    </Grid>
  );
};